// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"c8656657","144":"f748142a","260":"8b613aae","739":"1d873ccd","766":"3874c693","790":"219553c1","918":"98bbd078","941":"8d3147fc","975":"8b613aae"}[chunkId] + ".chunk.css";
};